import { Card, Group, SegmentedControl, Text } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import { IconCalendar } from '@tabler/icons-react'
import { ReactNode } from 'react'

const MIN_DATE = new Date(2026, 1, 27)

const clampStart = (date: Date) => (date < MIN_DATE ? MIN_DATE : date)

export const getPresetRange = (preset: string): [Date, Date] => {
  const now = new Date()
  switch (preset) {
    case 'today': {
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      return [clampStart(start), now]
    }
    case '1d':
      return [clampStart(new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000)), now]
    case '7d':
      return [clampStart(new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)), now]
    case '30d':
      return [clampStart(new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)), now]
    case '1y':
      return [clampStart(new Date(now.getFullYear() - 1, now.getMonth(), now.getDate())), now]
    default:
      return [clampStart(new Date(now.getFullYear(), now.getMonth(), now.getDate())), now]
  }
}

const DEFAULT_PRESETS = [
  { label: '24h', value: '1d' },
  { label: '7d', value: '7d' },
  { label: '30d', value: '30d' },
  { label: '1y', value: '1y' },
  { label: 'Custom', value: 'custom' },
]

interface FilterBarProps {
  preset: string
  onPresetChange: (value: string) => void
  dateRange: [Date | null, Date | null]
  onDateRangeChange: (value: [Date | null, Date | null]) => void
  extraFilters?: ReactNode
  presets?: { label: string; value: string }[]
}

export function FilterBar({
  preset,
  onPresetChange,
  dateRange,
  onDateRangeChange,
  extraFilters,
  presets = DEFAULT_PRESETS,
}: FilterBarProps) {
  return (
    <Card padding="md">
      <Group align="flex-end" gap="md" wrap="wrap">
        <div>
          <Text size="xs" fw={500} mb={4} c="dimmed">Time Range</Text>
          <SegmentedControl
            size="xs"
            value={preset}
            onChange={onPresetChange}
            data={presets}
          />
        </div>
        <DatePickerInput
          type="range"
          allowSingleDateInRange
          label="Date Range"
          placeholder="Select dates"
          value={dateRange}
          onChange={onDateRangeChange}
          leftSection={<IconCalendar size={14} />}
          minDate={MIN_DATE}
          maxDate={new Date()}
          clearable
          size="xs"
          style={{ minWidth: 220 }}
        />
        {extraFilters}
      </Group>
    </Card>
  )
}
